import style from "./RangeSlider.module.css"
import {useEffect} from "react";

function RangeSlider(props) {

    useEffect(() => {
        if(document.getElementById(props.id)){
            document.getElementById(props.id).oninput = function() {
                let value = (this.value-this.min)/(this.max-this.min)*100
                this.style.background = 'linear-gradient(to right, lightblue 0%, lightblue ' + value + '%, #E8E8E8 ' + value + '%, #E8E8E8 100%)'
            };
        }
    },[props.value])

    return (
        <div className={"row"} style={{alignItems:"center"}}>
            <div style={{border: "1px solid #1b7ea9", width: "59px"}}><span
                style={{fontSize: "14px", margin: ".5rem"}}>{props.value.toString().concat(" km")}</span></div>
            {/* L'input non ha <label> associata: senza aria-label sarebbe privo di nome
                accessibile (WCAG 4.1.2). aria-valuetext esprime il valore nell'unita'
                di misura reale (km), che altrimenti lo screen reader annuncerebbe come
                numero nudo. Attributi ARIA: nessun impatto sulla resa grafica. */}
            <input style={{width:"70%",marginLeft:"2%"}} id={props.id} type="range" className={style.slider}
                   aria-label={props.ariaLabel ? props.ariaLabel : "Raggio di ricerca in chilometri"}
                   aria-valuetext={props.value !== undefined && props.value !== null ? props.value.toString().concat(" km") : undefined}
                   min={"0"} max={"30"} value={props.value} onChange={props.onChange}/>

        </div>
    )


}

export default RangeSlider
